import { Form, Input, Select, notification, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import ImgCrop from 'antd-img-crop';
import GlobalService from '../../../../services/Global.service';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
export const checkValidForm = (fields, values) => {
    for (const [key, value] of Object.entries(values)) {
        if (fields.includes(key) && (!value || value?.length === 0)) {
            return false;
        }
    }
    return true;
};

const FreeForm = (props) => {
    const { t, i18n } = useTranslation();
    const { form } = props;
    const [fileList, setFileList] = useState([]);
    let lang = i18n.language;
    const values = form.getFieldsValue();

    const getImage = async (logoId) => {
        try {
            const { data } = await GlobalService.getImage(logoId);
            if (data.resultData?.imageId) {
                setFileList([
                    {
                        uid: '-1',
                        name: 'image.png',
                        status: 'done',
                        url: `data:image/png;base64,${data.resultData?.imageId}`,
                    },
                ]);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const beforeUpload = (file) => {
        const isJpgOrPng =
            file.type === 'image/jpeg' || file.type === 'image/png';

        if (!isJpgOrPng) {
            notification['error']({
                message: t('COOKIE.YouUploadFile', { ns: 'translation' }),
            });
        }

        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
            notification['error']({
                message: t('COOKIE.ImageMustSmaller', { ns: 'translation' }),
            });
        }

        return isJpgOrPng && isLt2M;
    };

    const onPreview = async (file) => {
        let src = file.url;

        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);

                reader.onload = () => resolve(reader.result);
            });
        }

        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };

    const uploadButton = (
        <div>
            <svg
                width={17}
                height={17}
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.16536 5.16732H7.83203V7.83398H5.16536V9.16732H7.83203V11.834H9.16536V9.16732H11.832V7.83398H9.16536V5.16732ZM8.4987 1.83398C4.8187 1.83398 1.83203 4.82065 1.83203 8.50065C1.83203 12.1807 4.8187 15.1673 8.4987 15.1673C12.1787 15.1673 15.1654 12.1807 15.1654 8.50065C15.1654 4.82065 12.1787 1.83398 8.4987 1.83398ZM8.4987 13.834C5.5587 13.834 3.16536 11.4407 3.16536 8.50065C3.16536 5.56065 5.5587 3.16732 8.4987 3.16732C11.4387 3.16732 13.832 5.56065 13.832 8.50065C13.832 11.4407 11.4387 13.834 8.4987 13.834Z"
                    fill="#1890FF"
                />
            </svg>
            <div className="-mt-2 text-blue-500 opacity-90">
                {t('policy.ChooseFile', { ns: 'translation' })}
            </div>
        </div>
    );
    useEffect(() => {
        if (values?.freeFormCompanyLogoId) getImage(values?.freeFormCompanyLogoId);
    }, [values?.freeFormCompanyLogoId]);

    const uploadProps = {
        multiple: false,
        listType: 'picture-card',
        beforeUpload,
        accept: '.png,.jpg,.jpeg',
        className: 'policy',
        fileList,
        onPreview,
        onChange(info) {
            const { status } = info.file;
            if (status === 'uploading') {
                info.file.status = 'done';
            }
            if (status === 'done' || status === 'removed') {
                setFileList(info.fileList);

                if (info.file.response?.resultData?.imageId) {
                    form.setFieldsValue({
                        freeFormCompanyLogoId: info.file.response.resultData.imageId,
                    });
                }
            }
        },
        onSuccess(res, file) {
            form.setFieldsValue({
                freeFormCompanyLogoId: res.imageId,
            });
            const updatedValues = form.getFieldsValue();
            onValuesChange({ freeFormCompanyLogoId: res.imageId }, updatedValues);
            setFileList([file]);
        },
        onError(err) {
            console.log('Error uploading image:', err);
        },
        onRemove() {
            form.setFieldsValue({
                freeFormCompanyLogoId: null,
            });
        },
        customRequest: async ({ file, onSuccess, onError, onProgress }) => {
            let fileList = new FormData();
            fileList.append('image', file);
            fileList.append('fileName', file.name);
            fileList.append('action', 'image-create-application');

            try {
                const onUploadProgress = ({ total, loaded }) => {
                    onProgress(
                        {
                            percent: Math.round((loaded / total) * 100).toFixed(2),
                        },
                        file
                    );
                };
                const { data } = await GlobalService.uploadImage(
                    fileList,
                    onUploadProgress
                );
                if (data?.resultData?.imageId) {
                    onSuccess(data?.resultData, file);
                } else {
                    onError('error');
                }
            } catch (error) {
                onError(error);
            }
        },
    };


    useEffect(() => {
        if (props.editMode) {
            const {
                freeFormPolicyNameTh,
                freeFormPolicyNameEn,
                freeFormPolicyDataSubjectType,
                freeFormCompanyNameTh,
                freeFormCompanyNameEn,
                freeFormIntroductionTh,
                freeFormIntroductionEn,
                freeFormCompanyLogoId
            } = props.editData;
            form.setFieldsValue({
                freeFormPolicyNameTh: freeFormPolicyNameTh || '',
                freeFormPolicyNameEn: freeFormPolicyNameEn || '',
                freeFormPolicyDataSubjectType:
                    freeFormPolicyDataSubjectType || [],
                freeFormCompanyNameTh: freeFormCompanyNameTh || '',
                freeFormCompanyNameEn: freeFormCompanyNameEn || '',
                freeFormIntroductionTh: freeFormIntroductionTh || '',
                freeFormIntroductionEn: freeFormIntroductionEn || '',
                freeFormCompanyLogoId: freeFormCompanyLogoId,

            });
            if (freeFormCompanyLogoId) {
                getImage(
                    freeFormCompanyLogoId
                );
            }
        }

    }, [props.editMode]);

    useEffect(() => {
        if (props?.previewData?.personalDataCollection) {
            onValuesChange(null, props.previewData?.personalDataCollection);
        }
    }, [props?.previewData]);

    const onValuesChange = (changedValues, allValues) => {
        const isFreeFormPolicyNameTh = allValues.freeFormPolicyNameTh && allValues.freeFormPolicyNameTh.trim() !== '';
        const isFreeFormPolicyNameEn = allValues.freeFormPolicyNameEn && allValues.freeFormPolicyNameEn.trim() !== '';
        const isFreeFormPolicyDataSubjectType = allValues.freeFormPolicyDataSubjectType

        if (isFreeFormPolicyNameTh && isFreeFormPolicyNameEn && isFreeFormPolicyDataSubjectType.length > 0) {
            props.handleError(0, true);
        } else {
            props.handleError(0, false);
        }
        props.onValuesChange(changedValues, allValues);
    };


    return (
        <div className="px-4 block_">
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                name="freeFormPolicy"
                layout="vertical"
                form={form}
                onValuesChange={onValuesChange}
            >
                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            {t('Name of the privacy')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="freeFormPolicyNameTh"
                >
                    <Input
                        addonBefore="TH"
                        size="large"
                        placeholder={t('Specify the policy name')}
                    />
                </Form.Item>
                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                    name="freeFormPolicyNameEn"
                >
                    <Input
                        addonBefore="EN"
                        size="large"
                        placeholder={t('Specify the policy name')}
                    />
                </Form.Item>
                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            {t(
                                'What types of data subjects does this policy apply to'
                            )}
                        </span>
                    }
                    className="mt-4"
                    name="freeFormPolicyDataSubjectType"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Select
                        placeholder={t('Select data subject type')}
                        style={{ width: '100%' }}
                        size="large"
                        allowClear
                        mode="multiple"
                    >
                        {props.dsType?.map((dsType) => (
                            <Select.Option key={dsType?.id} value={dsType?.id}>
                                {dsType?.nameTh}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label={
                        <span className="text-[21px] font-bold">
                            {t('Organization name')}
                        </span>
                    }
                    name="freeFormCompanyNameTh"
                >
                    <Input
                        addonBefore="TH"
                        size="large"
                        placeholder={t('Organization name placeholder th')}
                    />
                </Form.Item>
                <Form.Item
                    name="freeFormCompanyNameEn"
                >
                    <Input
                        addonBefore="EN"
                        size="large"
                        placeholder={t('Organization name placeholder en')}
                    />
                </Form.Item>
                <label>
                    <span className="text-[21px] font-bold">
                        {t('Introduction')}
                    </span>
                </label>
                <Form.Item
                    label={t('Content th')}
                    name="freeFormIntroductionTh"
                >
                    <Editor
                        placeholder={t('Specify content th')}
                    />
                </Form.Item>
                <Form.Item
                    label={t('Content EN')}
                    name="freeFormIntroductionEn"
                >
                     <Editor
                        placeholder={t('Specify content en')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'freeFormCompanyLogoId'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('UploadLogo')}
                        </span>
                    }
                >
                    <ImgCrop
                        beforeCrop={beforeUpload}
                        showGrid
                        rotationSlider
                        aspectSlider
                        showReset
                    >
                        <Upload {...uploadProps}>
                            {fileList?.length < 1 && uploadButton}
                        </Upload>
                    </ImgCrop>
                </Form.Item>
                <div className="-mt-6 text-gray-400 text-10">
                    {lang === 'en'
                        ? '*Max size of 2 MB. (Allowed file types: jpg., .png.)'
                        : '*ขนาดสูงสุด 2 MB. (ประเภทไฟล์ที่อนุญาต: jpg., .png.)'}
                </div>
            </Form>
        </div>
    );
};
export default FreeForm;
